export const EMPTY_DURATION_VALUE = {
  type: 'DURATION',
  value: 0,
  unit: 'DAY',
};

// Window should not be larger than 2 years by default
export const MAX_WINDOW_SIZE_IN_YEARS_DEFAULT = 2;
